<template>
  <div>
    <div class="login-wrp">
      <img class="login-icon c-p" src="../assets/cosmolove-logo-3.png" @click="goHome" />
      <div class="login-content clearfix">
        <img class="login-banner pull-left" src="../assets/login_qrcode.png" />
        <form class="login-form pull-right" @submit.prevent="login()">
          <h4 class="login-form-header">注册</h4>
          <input placeholder="请输入手机号" type="text" class="f-w login-f-control m-b" v-model="telephone" />
          <div class="f-w">
            <input placeholder="请输入图片验证码" type="text" class="login-f-control m-b" style="width: 185px;" v-model="captcha" />
            <img class="captcha-img" src="/api/common/captcha/"/>
          </div>
          <div class="f-w">
            <input placeholder="请输入验证码" type="text" class="login-f-control m-b" style="width: 50%;" v-model="verifyCode" />
            <button class="c-b-login c-b-primary" role="button" :disabled="curCount > 0" style="width: 160px; float: right; overflow: hidden;" @click="getVerifyCode()">{{verifyMessage}}</button>
          </div>
          <input placeholder="设置密码" type="password" class="f-w login-f-control" v-model="password" />
          <button class="c-b-login c-b-primary m-t-md":disabled="registerDisabled()" @click="register()">注册</button>
          <div class="text-small text-gray" style="margin-top: 20px;">
            注册即表示同意
            <a class="link-text" target="_blank" href="#/user/policy">《时尚新娘用户协议》</a>
            <a class="link-text login" href="#/login">已有账号去登录></a>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  /* eslint-disable */
import toastr from 'mini-toastr';
import md5 from 'blueimp-md5';
import uService from '../service/user';

export default {
  name: 'Register',
  created() {
    if (uService.hasLogin()) {
      location.href = '#/';
    }
  },
  data() {
    return {
      telephone: undefined,
      password: undefined,
      captcha: undefined,
      verifyCode: undefined,
      verifyMessage: '获取验证码',
      InterValObj: undefined,
      count: 60,
      curCount: undefined,
      captchaUrl: undefined,
    };
  },
  methods: {
    register() {
      if (!this.telephone) {
        toastr.error('手机号不能为空');
        return false;
      }
      if (!this.captcha) {
        toastr.error('图形验证码不能为空');
        return false;
      }
      if (!this.password) {
        toastr.error('密码不能为空');
        return false;
      }
      if (!this.verifyCode) {
        toastr.error('验证码不能为空');
        return false;
      }
      uService.register(this.telephone, md5(this.password), this.captcha, this.verifyCode)
        .then(() => {
          location.href = '#/';
          toastr.success('注册成功');
        });
      return false;
    },
    setTime() {
      if (this.curCount === 0) {
        window.clearInterval(this.InterValObj);
        this.verifyMessage = '获取验证码';
      } else {
        this.curCount --;
        if (this.curCount >= 1) {
          this.verifyMessage = this.curCount + '秒';
        } else {
          this.verifyMessage = '获取验证码';
        }
      }
    },
    getVerifyCode() {
      if (!this.telephone) {
        toastr.error('手机号不能为空');
        return false;
      }
      if (!this.captcha) {
        toastr.error('图形验证码不能为空');
        return false;
      }
      uService.getVerifyCode(this.telephone, this.captcha, 1).then(() => {
        this.curCount = this.count;
        this.verifyMessage = this.curCount + '秒';
        this.InterValObj = window.setInterval(this.setTime, 1000);
        toastr.success('发送成功');
      },() => {
        toastr.warn('发送失败');
      });
      return true;
    },
    registerDisabled() {
      return !this.telephone || !this.password || !this.captcha || !this.verifyCode;
    },
    goHome() {
      this.$router.replace({ name: 'Index' });
    },
  },
};
</script>
<style scoped>
.login-wrp {
  width: 1000px;
  margin: 0 auto 71px;
}
.login-icon {
  width: 111px;
  height: 56px;
  margin-top: 24px;
}
.login-content {
  margin-top: 144px;
}
.login-form {
  width: 371px;
	height: 450px;
	border: solid 1px #e1e1e1;
  padding: 30px 35px;
}
.login-form-header {
  font-size: 18px;
  margin-bottom: 45px;
  margin-top: none;
  font-weight: normal;
}
.login {
  float: right;
  font-size: 12px;
}
.forget-pw {
  text-align: right;
  margin-top: 21px;
  font-size: 12px;
}
.forget-pw > a {
  color: #999;
}
.forget-pw > a:hover {
  color: #df3a4e;
  text-decoration: none;
}
.c-b:active,
.c-b:focus,
.c-b-login:active {}
.c-b-login:focus,
.f-control:focus {
  outline: 0 none;
}
.captcha-img{
  float: right;
  width: 160px;
  height: 40px;
}

</style>



// WEBPACK FOOTER //
// Register.vue?74700f7f